// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataInfo-module__ui-DataInfo--P4QQt {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 11px;
}

.DataInfo-module__heading--U2o79 {
  padding: 6px 0 1px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.5844px;
  white-space: nowrap;
  word-break: break-word;
}

.DataInfo-module__ui-DataInfo-Item--cJ3W6 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.2328px;
  white-space: nowrap;
  word-break: break-word;
}

.DataInfo-module__ui-DataInfo-Item--cJ3W6:not(:last-child) {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--chaek-color-border-divider);
}

.DataInfo-module__title--QNBQM {
  margin: 0;
  color: var(--chaek-color-text-muted);
}

.DataInfo-module__content--tlccz {
  margin: 0;
  color: var(--chaek-color-text-source-333333);
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/DataInfo/DataInfo.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,iBAAiB;AACnB","sourcesContent":[".ui-DataInfo {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 11px;\n}\n\n.heading {\n  padding: 6px 0 1px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1;\n  letter-spacing: -0.5844px;\n  white-space: nowrap;\n  word-break: break-word;\n}\n\n.ui-DataInfo-Item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n  white-space: nowrap;\n  word-break: break-word;\n}\n\n.ui-DataInfo-Item:not(:last-child) {\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--chaek-color-border-divider);\n}\n\n.title {\n  margin: 0;\n  color: var(--chaek-color-text-muted);\n}\n\n.content {\n  margin: 0;\n  color: var(--chaek-color-text-source-333333);\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-DataInfo": `DataInfo-module__ui-DataInfo--P4QQt`,
	"heading": `DataInfo-module__heading--U2o79`,
	"ui-DataInfo-Item": `DataInfo-module__ui-DataInfo-Item--cJ3W6`,
	"title": `DataInfo-module__title--QNBQM`,
	"content": `DataInfo-module__content--tlccz`
};
export default ___CSS_LOADER_EXPORT___;
